import { createSelector } from 'reselect';
import getUnenhancedOpenPurchase from './getUnenhancedOpenPurchase';
import getAvailableItems from './getAvailableItems';
import getUserUnderage from './getUserUnderage';
import { itemRequiresAlcohol } from '../utils/ordering/filterAlcoholic';

// same deal as getItemSizes, should no longer be needed
export default createSelector(
  [getUnenhancedOpenPurchase, getAvailableItems, getUserUnderage],
  (openPurchase, allItems, isUserUnderage) => {
    if (!allItems || !openPurchase) return;

    const openItem = allItems[openPurchase.itemId];

    if (!openItem.sizes.length) return;

    if (isUserUnderage) {
      return openItem.sizes.filter(
        size => !itemRequiresAlcohol(size as unknown as Item),
      );
    }

    return openItem.sizes;
  },
);
